<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myrequest.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myrequest.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.details') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper mt-30">
        <v-flex class="inner_basic_wrap type2">
          <v-tabs
            class="my_app_tabs_data type2"
            hide-slider
            grow
          >
            <v-tab>{{ $t('myrequest.view.fields.request_data') }}</v-tab>
            <v-tab>{{ $t('myrequest.view.fields.attached_document') }}</v-tab>

            <v-tab-item>
              <ApplicationInformation
                :receipt_no.sync = receipt_no
              />
              <h2 class="nec_title type3 mt-45" style="color:#fff;">{{ $t('myrequest.view.fields.withdrawal_request')  }}</h2>
              <div class="pa-20 pt-0 pb-0">
                <v-radio-group
                  row
                  v-model="typeCode"
                  class="view__radio"
                >
                  <template v-for="(code, i) in $vuetify.rtl ? typeCodeListAr : typeCodeListEn">
                    <v-radio
                      :key="code.value"
                      :label="$vuetify.rtl ? fnGetCodeLabel(code, typeNameAr) : fnGetCodeLabel(code, typeNameEn)"
                      :value="code.value"
                      readonly
                    >
                    </v-radio>
                    <v-spacer class="hidden_lr10" :key="i" v-if="i==0"></v-spacer>
                  </template>
                </v-radio-group>
              </div>
              <h2 class="nec_title type3 mt-45" style="color:#fff;" v-if="typeCode !== '5501'">{{ $t('myrequest.view.fields.reason_withdrawal')  }}</h2>
              <div v-if="typeCode !== '5501'">
                <v-row class="ma-0">
                  <v-col cols="12" class="pt-20">
                    <v-textarea
                      outlined
                      class="pl-20 pr-20 login_text_filed"
                      v-model="notes"
                      readonly
                    ></v-textarea>
                  </v-col>
                </v-row>
              </div>
            </v-tab-item>

            <v-tab-item>
              <DocumentViewer
                :items="documentFileList"
              />
            </v-tab-item>
          </v-tabs>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoList()"
              >{{ $t('common.button.go_to_list') }}</v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>

    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DocumentViewer from '@/components/layout/DocumentViewer'
import ApplicationInformation from '@/components/layout/ApplicationInformation'

export default {
  components :{
    DocumentViewer,
    ApplicationInformation
  },
  data () {
    return {
      receipt_no : this.$route.params.receipt_no,
      documentFileList: [],
      notes : '',
      typeCode : '',
      target_no : '',
      typeNameAr : '',
      typeNameEn : '',
      typeCodeListAr: [],
      typeCodeListEn: []
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetTypecode()
    this.fnGetContent()
    this.fnGetDocumentFileList()
  },
  methods: {
    fnGetTypecode(){
      let options = {
        upper_code: '5500'
      }
      utils.fnGetCodeList(options).then(list => {
        this.typeCodeListAr = list.ar
        this.typeCodeListEn = list.en
      })
    },
    fnGetContent(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.notes = res.data.notes
            this.target_no = res.data.withdrawal_target_receipt_no
            this.typeCode = res.data.withdrawal_type_code
            this.typeNameAr = res.data.withdrawal_type_name_ar
            this.typeNameEn = res.data.withdrawal_type_name_en
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGoList() {
      let url = location.href
      let qryStr = url.split('?')[1]
      this.$router.push('/myrequest/list?' + qryStr)
    },
    fnGetCodeLabel(code, name){
      let text = code.text
      if(code.value === '5502' && this.typeCode === '5502'){
        text += '(#' + this.target_no + ' ' + name +')'
      }
      return text
    }
  }
}
</script>